var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginEventos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.441,
    height: 69.443,
    viewBox: "0 0 69.441 69.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42755",
    "data-name": "Grupo 42755",
    transform: "translate(-699.999 -816.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42752",
    "data-name": "Grupo 42752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20865",
    "data-name": "Trazado 20865",
    d: "M921.3,743.746a34.721,34.721,0,1,1-34.721-34.721A34.721,34.721,0,0,1,921.3,743.746",
    transform: "translate(-151.862 107.401)",
    fill: "#ed92c8",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32155",
    "data-name": "Rect\\xE1ngulo 32155",
    width: 46.734,
    height: 36.346,
    transform: "translate(711.923 835.552)",
    fill: "#ce1080"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32156",
    "data-name": "Rect\\xE1ngulo 32156",
    width: 11.108,
    height: 36.346,
    transform: "translate(745.074 835.552)",
    fill: "#e49ac2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20900",
    "data-name": "Trazado 20900",
    d: "M878.1,752.61a2.146,2.146,0,1,1-2.13-2.39,2.268,2.268,0,0,1,2.13,2.39",
    transform: "translate(-152.7 87.898)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20901",
    "data-name": "Trazado 20901",
    d: "M904.064,752.61a2.147,2.147,0,1,1-2.135-2.39,2.272,2.272,0,0,1,2.135,2.39",
    transform: "translate(-159.041 87.898)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20902",
    "data-name": "Trazado 20902",
    d: "M901.152,750.389a4.834,4.834,0,0,1-4.535-5.079v-3.464a4.837,4.837,0,0,1,4.535-5.083h5.7a4.841,4.841,0,0,1,4.539,5.083v1.068h-1.9v-1.068a2.814,2.814,0,0,0-2.638-2.956h-5.7a2.817,2.817,0,0,0-2.637,2.956v3.464a2.817,2.817,0,0,0,2.637,2.954Z",
    transform: "translate(-158.268 91.184)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20903",
    "data-name": "Trazado 20903",
    d: "M875.193,750.389a4.839,4.839,0,0,1-4.545-5.079v-3.464a4.84,4.84,0,0,1,4.545-5.083h5.691a4.841,4.841,0,0,1,4.542,5.083v1.068h-1.9v-1.068a2.817,2.817,0,0,0-2.639-2.956h-5.691a2.817,2.817,0,0,0-2.645,2.956v3.464a2.818,2.818,0,0,0,2.645,2.954Z",
    transform: "translate(-151.926 91.184)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20904",
    "data-name": "Trazado 20904",
    d: "M885.052,767.24h1.791q2.126,0,2.122-2.329a2.137,2.137,0,0,0-.506-1.479,1.8,1.8,0,0,0-1.425-.571,1.94,1.94,0,0,0-1.31.49,1.564,1.564,0,0,0-.555,1.224h-3.788A4.68,4.68,0,0,1,882.1,762a4.893,4.893,0,0,1,2-1.769,6.974,6.974,0,0,1,7.1.756,4.9,4.9,0,0,1,1.564,3.841,4.247,4.247,0,0,1-.643,2.236,4.8,4.8,0,0,1-1.889,1.705,4.411,4.411,0,0,1,2.045,1.606,4.566,4.566,0,0,1,.744,2.661,4.937,4.937,0,0,1-1.688,3.926,6.479,6.479,0,0,1-4.429,1.475,6.575,6.575,0,0,1-2.99-.689,4.759,4.759,0,0,1-2.081-1.9,5.325,5.325,0,0,1-.71-2.759h3.813a2.091,2.091,0,0,0,2.1,2.078,2.114,2.114,0,0,0,1.6-.626,2.208,2.208,0,0,0,.592-1.591,2.592,2.592,0,0,0-.614-1.965,2.391,2.391,0,0,0-1.709-.581h-1.846Z",
    transform: "translate(-154.482 85.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32158",
    "data-name": "Rect\\xE1ngulo 32158",
    width: 41.785,
    height: 43.951,
    transform: "translate(714.398 827.948)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEventos);
export default __webpack_public_path__ + "static/media/Login_eventos.59acd8904e9bd2d9e4a5b986b9b06bb1.svg";
export { ForwardRef as ReactComponent };